import * as Types from '../../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetTrialAppAnnouncementBarsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetTrialAppAnnouncementBarsQuery = { __typename?: 'Query', trialModeAppAnnouncementBarList: Array<{ __typename?: 'TrialModeAppAnnouncementBarResult', appAnnouncementBarId: number, imageUrl: string, navigationType: string, navigationUrl: string, publishTime: any, stopTime: any, markets: Array<string>, isInUse: boolean }> };


export const GetTrialAppAnnouncementBarsDocument = gql`
    query getTrialAppAnnouncementBars {
  trialModeAppAnnouncementBarList {
    appAnnouncementBarId
    imageUrl @wf_blobSignature(name: "TRIAL_MODE_APP_ANNOUNCEMENT_BAR_IMAGES_SIGNATURE")
    navigationType
    navigationUrl
    publishTime
    stopTime
    markets
    isInUse
  }
}
    `;

/**
 * __useGetTrialAppAnnouncementBarsQuery__
 *
 * To run a query within a React component, call `useGetTrialAppAnnouncementBarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrialAppAnnouncementBarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrialAppAnnouncementBarsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTrialAppAnnouncementBarsQuery(baseOptions?: Apollo.QueryHookOptions<GetTrialAppAnnouncementBarsQuery, GetTrialAppAnnouncementBarsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrialAppAnnouncementBarsQuery, GetTrialAppAnnouncementBarsQueryVariables>(GetTrialAppAnnouncementBarsDocument, options);
      }
export function useGetTrialAppAnnouncementBarsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrialAppAnnouncementBarsQuery, GetTrialAppAnnouncementBarsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrialAppAnnouncementBarsQuery, GetTrialAppAnnouncementBarsQueryVariables>(GetTrialAppAnnouncementBarsDocument, options);
        }
export type GetTrialAppAnnouncementBarsQueryHookResult = ReturnType<typeof useGetTrialAppAnnouncementBarsQuery>;
export type GetTrialAppAnnouncementBarsLazyQueryHookResult = ReturnType<typeof useGetTrialAppAnnouncementBarsLazyQuery>;
export type GetTrialAppAnnouncementBarsQueryResult = Apollo.QueryResult<GetTrialAppAnnouncementBarsQuery, GetTrialAppAnnouncementBarsQueryVariables>;